import React, { useState } from "react";
import { Route, Redirect } from "react-router-dom";
import AdminSidebar from "../components/adminSidebar";
import { useAuth } from "../context/auth";
import { LuMenu } from "react-icons/lu";
import images from "../images";
import { Link } from "react-router-dom";
import usePersistentToggle from "../shared/hooks/usePersistentToggle";

const SIDEBAR_WIDTH = 240;
const SIDEBAR_COLLAPSED_WIDTH = 72;

const AdminRouteWrapper = ({
  component: Component,
  authOnly,
  roles,
  ...props
}) => {
  const { user, isReady } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Menu lateral recolhido (só ícones) — lembrado entre telas e sessões
  const { value: sidebarCollapsed, toggle: toggleSidebarCollapsed } =
    usePersistentToggle("svelta-admin:sidebar-collapsed", false);

  if (!isReady) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          background: "#f8fafc",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: 32,
              height: 32,
              border: "3px solid #e5e7eb",
              borderTopColor: "#111",
              borderRadius: "50%",
              animation: "spin 0.7s linear infinite",
              margin: "0 auto",
            }}
          />
          <p style={{ marginTop: 14, color: "#74818e", fontSize: 14 }}>
            Carregando...
          </p>
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (authOnly && !user) return <Redirect to="/" />;
  if (roles.length > 0 && (!user || !roles.includes(user.role)))
    return <Redirect to="/" />;

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f1f5f9" }}>
      <AdminSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapsed={toggleSidebarCollapsed}
      />

      {/* Mobile top bar */}
      <div
        style={{
          display: "none",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 56,
          background: "#fff",
          borderBottom: "1px solid #efefef",
          zIndex: 150,
          alignItems: "center",
          padding: "0 16px",
          gap: 16,
        }}
        className="admin-mobile-topbar"
      >
        <button
          onClick={() => setSidebarOpen(true)}
          style={{
            background: "none",
            border: "none",
            padding: 4,
            cursor: "pointer",
            display: "flex",
          }}
        >
          <LuMenu size={22} color="#111" />
        </button>
        <Link to="/admin-panel/Dashboard">
          <img src={images.svelta} alt="Svelta" style={{ width: 80 }} />
        </Link>
      </div>

      <main
        style={{
          marginLeft: sidebarCollapsed
            ? SIDEBAR_COLLAPSED_WIDTH
            : SIDEBAR_WIDTH,
          flex: 1,
          minWidth: 0,
          minHeight: "100vh",
          overflow: "auto",
          transition: "margin-left 0.2s ease",
        }}
        className="admin-main-content"
      >
        <Component {...props} />
      </main>

      <style>{`
        @media (max-width: 768px) {
          .admin-mobile-topbar { display: flex !important; }
          .admin-main-content { margin-left: 0 !important; padding-top: 56px; }
        }
        .admin-sidebar-backdrop { display: none; }
        @media (max-width: 768px) {
          .admin-sidebar-backdrop { display: block; }
        }
      `}</style>
    </div>
  );
};

const AdminLayoutRouter = ({
  component,
  authOnly = false,
  roles = [],
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => (
      <AdminRouteWrapper
        {...props}
        component={component}
        authOnly={authOnly}
        roles={roles}
      />
    )}
  />
);

export default AdminLayoutRouter;
